import { ISelectionConfig } from './selection-config.interface';
import { ITableColumn } from './table-column.interface';
import { ITableActions } from './table-actions.interface';

export interface ITableConfig {
  columns: ITableColumn[];
  rowIdKey: string;
  rowLabelKey: string;
  selectionConfig?: ISelectionConfig;
  actions?: ITableActions;
}
